import React, { useEffect, useState } from "react";
import { apiCallSPPost } from "src/_apiConfig/apiCall";
import Auth from "src/auth";
import CommonList from "src/views/common/CommonList";
import {
  CommonSearch,
  updateSearchStatus,
} from "src/views/common/CommonSearch";
import TableButtonClick from "src/views/common/Table/TableButtonClick";
import ReverseHistory from "../RevertHistory";
import ConfirmationPopup from "src/views/common/ConfirmationPopup";
import ReverseEntry from "../RevertEntry";

const RevertAdjustAmtFormDFO = () => {
  const { authenticated } = Auth();
  const [usersData, setUsersData] = useState(); // List Data Set
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading
  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10); // Record Show Each Page
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage
  const [lotPaymentId, setLotPaymentId] = useState();
  //Confirmation popup------------------------------------
  const [CPopUpId, setCPopUpId] = useState();
  const [CPopUpIndex, setCPopUpIndex] = useState();
  const [CPopUpDisplayConfirmationModal, setCPopUpDisplayConfirmationModal] =
    useState(false);

  const [showModal, setShowModal] = useState(false);

  // Page  API URL manage
  const ListUrl = `BackendActivity/ReverseEntry/AdjustAmtFormDFOByLotNo`;

  // api data manage
  const getdata = () => {
    const data = JSON.stringify({
      tenderNo: search.tenderNo.trim(),
      lot_no: search.lotNo.trim(),
      collection_season: Number(search.collectionSeason),
    });
    console.log("getdata", data);
    return data;
  };
  const SearchFilterModel = {
    collectionSeason:  new Date().getFullYear().toString(),
    tenderNo: "",
    lotNo: "",
    requestStartDate: "",
    requestEndDate: "",
  };
  // Search Model
  const [search, setSearch] = useState(SearchFilterModel);

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };
  useEffect(() => {
    setloading(false);
    reset();
    paggingManage(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getReportList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageLimit]);

  useEffect(() => {
    if (isSearch) {
      getReportList();
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);
  // pagging Disabled  manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  // pagging Disabled Manage
  const paggingManage = (totalRecord, isRecordGet = true) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };
  const reset = () => {
    setpageLimit(0);
  };
  // get Report List
  const getReportList = async () => {
    if (authenticated) {
      setloading(true);
      paggingDisabled();
      setUsersData([]);

      if (search.lotNo !== "") {
        await apiCallSPPost(ListUrl, getdata(), [])
          .then((res) => {
            if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
              paggingManage(pageCount);
            }
            if (res.success && res.totalRecord > 0) {
              console.log(res.data);
              setUsersData(res.data);
            } else setUsersData();
          })
          .finally(() => {
            setloading(false);
          });
      } else {
        setUsersData();
        setloading(false);
      }
    }
  };

  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitCheck = pageLimit - parseInt(itemPerPage);
    if (pageLimitCheck < 0) {
      pageLimitCheck = 0;
    }
    setpageLimit(pageLimitCheck);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitCheck = pageLimit + parseInt(itemPerPage);
    if (pageLimitCheck >= parseInt(pageCount)) {
      pageLimitCheck = parseInt(pageCount);
      setdisablednext(true);
    }
    setpageLimit(pageLimitCheck);
  };
  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    reset();
    setIsSearch(true);
  };

  const clearSearch = (ev) => {
    ev.preventDefault();
    reset();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    setUsersData([]);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
  };

  const handleConfirmationPopUpModalClose = () =>
    setCPopUpDisplayConfirmationModal(false);

  const SubmitConfirmationPopUpResponse = async () => {
    setShowModal(true);
    setCPopUpIndex(-1);
    handleConfirmationPopUpModalClose();
    console.log("Check:", lotPaymentId);
  };
  const handleCofirmationOpen = async (id) => {
    setCPopUpDisplayConfirmationModal(true);
    setCPopUpId(1);
    setLotPaymentId(id);
  };

  const scopedSlotsCommon = {
    ValueOfIsFullPaymentDone: (item, index) => {
      //console.log("scopedSlotsCommon", item, index);
      return (
        <td className="py-2">
          <span>{item.isFullPaymentDone ? "Yes" : "No"}</span>
        </td>
      );
    },
    ValueOfIsPaymentDone: (item, index) => {
      //console.log("scopedSlotsCommon", item, index);
      return (
        <td className="py-2">
          <span>{item.isPaymentDone ? "Yes" : "No"}</span>
        </td>
      );
    },
    ValueOfAdjustmentByDFOId: (item, index) => {
      //console.log("scopedSlotsCommon", item, index);
      return (
        <td className="py-2">
          <span>
            {item.installmentAdjustmentByDFOId > 0 ? "Done" : "Pending"}
          </span>
        </td>
      );
    },

    actionSet: (item, index) => {
      //console.log("scopedSlotsCommon", item, index);
      return (
        <TableButtonClick
          buttonName={"Revert Entry"}
          isDisplayAllow={
            item.installmentAdjustmentByDFOId > 0 &&
            item.isPaymentDone === false
              ? true
              : false
          }
          isButtonLoader={true}
          onClick={() => handleCofirmationOpen(item.id)}
        />
      );
    },
  };

  const fields = [
    // {
    //   key: "srNo",
    //   _style: { width: "5%" },
    //   label: "S.N.",
    // },
    {
      key: "tenderNo",
      _style: { width: "6.5%" },
      label: "Tender No.",
    },
    {
      key: "lotNo",
      _style: { width: "6.5%" },
      label: "Lot No.",
    },
    {
      key: "companyName",
      _style: { width: "15%" },
      label: "Company Name",
    },

    {
      key: "ValueOfAdjustmentByDFOId",
      _style: { width: "7.5%" },
      label: "Adjustment By DFO ",
    },

    {
      key: "ValueOfIsPaymentDone",
      _style: { width: "5%" },
      label: "Paid Done",
    },
    // {
    //   key: "paidStatus",
    //   _style: { width: "5%" },
    //   label: "Paid Status",
    // },

    {
      key: "ValueOfIsFullPaymentDone",
      _style: { width: "7.5%" },
      label: "Full Payment ",
    },

    {
      key: "actionSet",
      _style: { width: "15%" },
      label: "Action",
    },
  ];

  const additional = (
    <>
      {
        <div style={{ color: "red" }}>
          <div>
            <h5>
              <strong>
                {" "}
                Notes : Revert Adjustment amount for last instalment added by
                DFO from Backend{" "}
              </strong>
            </h5>
            If a Purchaser has already applied for an Adjustment amount for last
            instalment by DFO but has not completed the payment and wishes to
            revert the Adjustment amount from the backend, the following process
            should be followed:{" "}
          </div>
          <ul>
            <li>
              <strong>Payment Timeline : </strong> Ensure the last payment was
              made at least 3 days prior. Updating the status beyond this period
              may result in complications. Additionally, decisions on such
              updates should consider the Purchaser’s urgency.
            </li>
            <li>
              <strong>Challan Status : </strong> Verify that the Purchaser has
              neither downloaded the challan nor submitted it to the bank. Once
              the backend update is completed, the Purchaser must generate a new
              payment challan through the portal and proceed with bank
              submission.
            </li>
            <li>
              <strong>Authorization Requirement : </strong>This backend update
              should only be performed upon receiving an official request and
              authorization from the department in the form of a formal letter.
            </li>
          </ul>
          <hr />
        </div>
      }
      <CommonSearch
        isDisabledSearchClear={loading}
        isClear={isClear}
        search={search}
        updateSearch={updateSearch}
        searchButton={searchButton}
        clearSearch={clearSearch}
        itemPerPage={itemPerPage}
        onChangePage={onChangePage}
        isEmailAddressDisplay={false}
        isLotNumberDisplay={true}
        isExportToExcelDisplay={false}
        isExporting={false}
        isAfterSearchDataDisplay={true}
      />
    </>
  );

  return (
    <>
      <CommonList
        items={usersData}
        fields={fields}
        scopedSlots={scopedSlotsCommon}
        listName="Revert - Adjustment Amount Form DFO "
        loading={loading}
        additional={additional}
        prev={prevButton}
        next={nextButton}
        disabledprev={disabledprev}
        disablednext={disablednext}
        isAfterSearchDataDisplay={true}
        displayPaggingButton={false}
      />
      {usersData &&
        search.tenderNo !== undefined &&
        search.lotNo !== undefined && (
          <ReverseHistory
            tenderNo={search.tenderNo.trim()}
            lot_no={search.lotNo.trim()}
            collection_season={Number(search.collectionSeason)}
            reverse_type_id={3}
            isSearch={isSearch}
          />
        )}
      <ConfirmationPopup
        showModal={CPopUpDisplayConfirmationModal}
        hideModal={handleConfirmationPopUpModalClose}
        confirmModal={SubmitConfirmationPopUpResponse}
        id={CPopUpId}
        index={CPopUpIndex}
        ModalBody={"Are you sure you want to Revert Entry?"}
        //ModalTitle={CPopUpTitle}
        confirmButtonCss="btn btn-danger"
        //ButtonLoader={CPopUpButtonLoader}
      />
      <ReverseEntry
        search={search}
        showModal={showModal}
        setShowModal={setShowModal}
        setloading={setloading}
        //SetCPopUpButtonLodaer={SetCPopUpButtonLodaer}
        setCPopUpIndex={setCPopUpIndex}
        lotPaymentId={lotPaymentId}
        reverseTypeId={3}
        reverseSubTypeId={0}
      />
    </>
  );
};

export default RevertAdjustAmtFormDFO;
